import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomProductScopeService {


  url = environment.serverAPI4 + "/api/customproductscope"; 
  
  constructor(private http: HttpClient) { }

  getAllCustomerProductScope(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllCustomerProductScopeDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }
  


  getCustomerProductScopeById(customProductScopeId: number): Observable<Object> {
    return this.http.get(`${this.url}/${customProductScopeId}`);
  }

  addOrEditcustomerProductScope(customerProductScope: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, customerProductScope);
  }

  customerProductScopeSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

}
